<main class="mat-body" *ngIf="contract">
    <div class="container progress-bar-wrapper">
        <div class="row">
            <div class="col-12" *ngIf="!contract || !contract.isAdvisoryModelGDC()">
                <thr-contract-progress [percent]="80" *ngIf="!canFinalizeContract"></thr-contract-progress>
                <thr-contract-progress [percent]="100" *ngIf="canFinalizeContract"></thr-contract-progress>
            </div>
            <div class="col-12" *ngIf="contract && contract.isAdvisoryModelGDC()">
                <thr-contract-progress-gdc [percent]="80" *ngIf="!canFinalizeContract"></thr-contract-progress-gdc>
                <thr-contract-progress-gdc [percent]="100" *ngIf="canFinalizeContract"></thr-contract-progress-gdc>
            </div>
        </div>
    </div>

    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="row flex-nowrap justify-content-between align-items-end">
                    <div class="col-auto flex-shrink-1">
                        <h1 class="text-blue mat-display-1 mb-0" [innerHTML]="'full-data.complete-data'|translate" *ngIf="!user || !user.isAdmin"></h1>
                        <h1 class="text-blue mat-display-1 mb-0" [innerHTML]="'full-data.validate-data'|translate" *ngIf="user?.isAdmin"></h1>
                    </div>
                    <div class="col-auto">
                        <i class="icon-full-natural text-blue"></i>
                    </div>
                </div>
                <hr class="mt-1" />
                <h2 class="mat-subheading-1 text-blue font-weight-bold mb-4">{{ 'full-data.complete-all-data'|translate }}
                </h2>
            </div>
        </div>
    </div>

    <div class="container">
        <div class="row mt-4 mb-5" *ngIf="(!user || !user.isAdmin) && !contract?.isAdvisoryModelGDC()">
            <div class="col-12">
                <h2 class="mat-subheading-1 text-blue font-weight-bold mb-3">{{ 'full-data.account'|translate }}</h2>
                <thr-full-data-iban-table [iban]="contract.iban" [isAdmin]="user?.isAdmin" [isComplete]="contract.isComplete()" [isValidated]="contract.isValidated() || contract.validation.isValid()" (edit)="onEditAccount()">
                </thr-full-data-iban-table>
            </div>
        </div>

        <div class="row mt-4 mb-5" *ngIf="isLegalPerson">
            <div class="col-12">
                <h2 class="mat-subheading-1 text-blue font-weight-bold mb-3">{{ 'form.business'|translate }}</h2>
                <thr-full-data-legal-table [isAdmin]="user?.isAdmin" [isAdminPBC]="user?.isAdminPBC" [participants]="participants" (edit)="onEdit($event)"></thr-full-data-legal-table>
            </div>
        </div>

        <div class="row mt-4 mb-5">
            <div class="col-12">
                <h2 class="mat-subheading-1 text-blue font-weight-bold mb-3">
                    <span *ngIf="!isLegalPerson">{{ 'form.participants'|translate }}</span>
                    <span *ngIf="isLegalPerson">{{ 'form.attorneys-in-fact'|translate }}</span>
                </h2>
                <thr-full-data-participants-table [isAdmin]="user?.isAdmin" [isAdminPBC]="user?.isAdminPBC" [isGDC]="contract.isAdvisoryModelGDC()" [isLegalPerson]="isLegalPerson" [participants]="participants" (edit)="onEdit($event)"></thr-full-data-participants-table>
            </div>
        </div>

        <div class="row mt-4 mb-5" *ngIf="user?.isAdmin && !user?.isAdminPBC && canValidateContract">
            <div class="col-12">
                <h2 class="mat-subheading-1 text-blue font-weight-bold mb-3">{{ 'full-data.account'|translate }}</h2>
                <thr-full-data-iban-table [iban]="contract.iban" [isAdmin]="user?.isAdmin" [isComplete]="contract.isComplete()" [isValidated]="contract.isValidated() || contract.validation.isValid()" (edit)="onEditAccount()">
                </thr-full-data-iban-table>
            </div>
        </div>

        <div class="row justify-content-end mt-4 mb-5">
            <ng-container *ngIf="!user || !user.isAdmin">
                <div class="col-12 col-sm-6 col-md-4">
                    <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="blue" (click)="onCancel()">
                        {{ 'general.cancel'|translate }}
                    </button>
                </div>
                <div class="col-12 col-sm-6 col-md-4 mt-3 mt-sm-0">
                    <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="blue" [disabled]="!canFinalizeContract" (click)="onFinalize()">
                        {{ 'general.finalize'|translate }}
                    </button>
                </div>
            </ng-container>
            <ng-container *ngIf="user?.isAdmin">
                <div class="col-12 col-sm-6 col-md-4">
                    <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="blue" [disabled]="!canFinalizeContractAdmin" (click)="onValidateFinalize()">
                        {{ 'general.finalize'|translate }}
                    </button>
                </div>
            </ng-container>
        </div>
    </div>
</main>
